import { Component, Input, OnInit, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { EntriesExposedService } from '../../data-access/entries-exposed.service';
import { AmountPipe } from '../../../payments/payment/pipes/amount.pipe';
import { CommonModule } from '@angular/common';
import { TimestampPipe } from '../../../payments/payment/pipes/timestamp.pipe';
import { CartStatusComponent } from '../../ui/cart-status/cart-status.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { EntryDetailsDialogComponent } from '../../ui/entry-details-dialog/entry-details-dialog.component';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatIcon,
    AmountPipe,
    CommonModule,
    TimestampPipe,
    CartStatusComponent,
    MatDialogModule,
    MatButton
  ],
  providers: [
    EntriesExposedService
  ],
  selector: 'equine-ui-nx-entries-list',
  templateUrl: './entries-list.component.html',
  styleUrls: ['./entries-list.component.scss']
})
export class EntriesListComponent implements OnInit {

  private entriesExposedService = inject(EntriesExposedService);
  public dialog = inject(MatDialog);
  private router = inject(Router);

  @Input({ required: true }) userId!: string;

  entriesTable = [];
  displayedColumns = ['showId', 'showName', 'timestamp', 'summary', 'total', 'action'];

  totalLines = 0;
  pageSizeOptions: number[] = [10, 20, 50];
  pageSize = 10;
  pageIndex = 0;

  ngOnInit() {
    this.fetchTableData();
  }

  fetchTableData() {
    this.entriesExposedService.getEntriesByUserId(this.userId, this.pageSize, this.pageIndex)
      .subscribe({
        next: (response: any) => {
          debugger;
          this.totalLines = response?.metadata?.count;
          this.entriesTable = response?.data;
        }
      })
  }

  onPaginationChange(paginationChange: any) {
    this.pageSize = paginationChange.pageSize;
    this.pageIndex = paginationChange.pageIndex;

    this.fetchTableData();
  }

  openDetailsDialog(entry: any) {
    this.dialog.open(EntryDetailsDialogComponent, {
      data: entry
    })
  }

}
